import React from "react";
import TagManager from "react-gtm-module";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Provider } from "react-redux";
import { HelmetProvider, Helmet } from "react-helmet-async";
import store from "./store";

import SearchPage from "./pages/Search";
import BuilderSearchResultsPage from "./pages/BuilderSearchResults";
import EnrolmentSearchResultsPage from "./pages/EnrolmentSearchResults";
import ProfilePage from "./pages/Profile";
import UmbrellaProfilePage from "./pages/UmbrellaProfile";
import UnlicensedProfilePage from "./pages/UnlicensedProfile";
import GlossaryPage from "./pages/OBDGlossary";
import TermsOfUsePage from "./pages/TermsOfUse";
import ErrorPage from "./pages/ErrorPage";
import RecentCourtCharges from "./pages/RecentCourtCharges";
import NoticesOrders from "./pages/NoticesOrders";
import DisciplineAppeals from "./pages/DisciplineAppeals";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";

function App() {
  const tagManagerArgs = {
    gtmId: "G-VDYZTHM9ZE",
  };

  TagManager.initialize(tagManagerArgs);
  return (
    <HelmetProvider>
      <Provider store={store}>
        <Helmet>
          <meta
            name="description"
            content="The Home Construction Regulatory Authority (HCRA) regulates new home builders and vendors in the province. We protect the public interest by fostering a fair, safe and informed marketplace that supports the goal of a continuously improved home building industry in Ontario. The HCRA holds licensed builders to professional standards and works to enhance consumer confidence in the home building industry in Ontario. In addition, the HCRA strives to educate consumers to ensure that they can make informed decisions and understand the benefits of a regulated home building sector. The HCRA is a not-for-profit corporation that is designated by the provincial government to administer and enforce the New Home Construction Licensing Act, 2017 and associated regulations."
          />
          <meta
            name="keywords"
            content="home building, home construction, home builders, consumer protection, homebuyer, homeowner, home buying, home construction regulatory authority, hcra, building industry, ontario builder directory, regulatory authority, ontario regulations, tarion, tarion warranty corporation, builder licence, new home ontario, home owner, builder licence, ontario home builders association, ohba, tim hadwen, cpbh, canadians for properly built homes, Barbara Captijn, Karen Somerville, Virginia West, bereavement authority of ontario, condominium authority of ontario, cao, condominium management regulatory authority of ontario, cmrao, electrical safety authority, ontario one call, ontario motor vehicle industry council, omvic, real estate council of ontario, reco, retirement homes regulatory authority, rhra, technical standards and safety authority, tssa, travel industry council of ontario, tico, vintners quality alliance ontario, vqao"
          />
          <meta name="author" content="@hcraontario" />
          <meta name="siteUrl" content="https://obd.hcraontario.ca" />
          <meta name="theme-color" content="#008f68" />
          <script>
            {`!function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement("script");t.src="https://www.redditstatic.com/ads/pixel.js",t.async=!0;var s=d.getElementsByTagName("script")[0];s.parentNode.insertBefore(t,s)}}(window,document);rdt('init','a2_gq0h5g5fpeny');rdt('track', 'PageVisit');`}
          </script>
          <script
            async
            src="https://www.googletagmanager.com/gtag/js?id=G-VDYZTHM9ZE"
          ></script>
          <script
            async
            src="https://www.googletagmanager.com/gtag/js?id=AW-10869963483"
          ></script>
          <script>{`window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'AW-10869963483');`}</script>
        </Helmet>

        <Router>
          <ErrorBoundary>
            <Routes>
              <Route path="/buildersearchresults" element={<BuilderSearchResultsPage />} />
              <Route path="/charges-and-convictions" element={<RecentCourtCharges />} />
              <Route path="/notices-and-orders" element={<NoticesOrders />} />
              <Route path="/disclipline-appeals" element={<DisciplineAppeals />} />
              <Route path="/enrolmentsearchresults" element={<EnrolmentSearchResultsPage />} />
              <Route path="/profile/:id" element={<ProfilePage />} />
              <Route path="/umbrella/:id" element={<UmbrellaProfilePage />} />
              <Route path="/unlicensed/:id" element={<UnlicensedProfilePage />} />
              <Route path="/glossary" element={<GlossaryPage />} />
              <Route path="/terms-of-use" element={<TermsOfUsePage />} />
              <Route path="/" element={<SearchPage />} />
              <Route path="/error" element={<ErrorPage />} />
              <Route path="*" element={<ErrorPage />} />
            </Routes>
          </ErrorBoundary>
        </Router>
      </Provider>
    </HelmetProvider>
  );
}

export default App;
